
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l/[source]",
      function () {
        return require("private-next-pages/l/[source]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l/[source]"])
      });
    }
  